import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=f7df4a6a&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=f7df4a6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7df4a6a",
  null
  
)

export default component.exports